import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { _studentsCount } from 'store/selectors/Room'
import { _userInfo } from 'store/selectors/User'

import { responseTypes } from '../../constants'
import { Correct, Incorrect, Timedout } from '../../Headers'

const Header = ({ choices, isTeacher }) => {
    const [header, setHeader] = useState({
        title: '',
        type: responseTypes.CORRECT,
        answersCount: {
            correct: 0,
            incorrect: 0,
            unattempted: 0,
        },
    })

    const studentsCount = useSelector(_studentsCount)

    const localUserInfo = useSelector(_userInfo)

    useEffect(() => {
        if (!isTeacher || !choices) return

        let correctAnswerCount = 0
        let wrongAnswerCount = 0
        let tempHeaderObj = {}

        const loopThroughChoices = Object.values(choices)?.forEach(
            ({ is_answer, users }) => {
                if (is_answer) {
                    correctAnswerCount = users.length
                } else {
                    wrongAnswerCount += users.length
                }
            }
        )

        const unattemptedCount =
            studentsCount - (correctAnswerCount + wrongAnswerCount)

        if (correctAnswerCount + wrongAnswerCount === 0) {
            tempHeaderObj = {
                title: 'No student attempted',
                type: responseTypes.INCORRECT,
            }
        } else if (wrongAnswerCount === studentsCount) {
            tempHeaderObj = {
                title: `
                    All students answered incorrectly`,
                type: responseTypes.INCORRECT,
            }
        } else if (correctAnswerCount === studentsCount) {
            tempHeaderObj = {
                title: `All students answered correctly`,
                type: responseTypes.CORRECT,
            }
        } else if (wrongAnswerCount >= correctAnswerCount) {
            tempHeaderObj = {
                title: `
                    ${wrongAnswerCount}/${studentsCount} students answered incorrectly`,
                type: responseTypes.INCORRECT,
            }
        } else {
            tempHeaderObj = {
                title: `${correctAnswerCount}/${studentsCount} students answered correctly`,
                type: responseTypes.CORRECT,
            }
        }
        setHeader({
            ...tempHeaderObj,
            answersCount: {
                correct: correctAnswerCount,
                incorrect: wrongAnswerCount,
                unattempted: unattemptedCount,
            },
        })
    }, [isTeacher, choices])

    useEffect(() => {
        if (isTeacher) return

        const choicesArr = Object.values(choices)
        const tempHeader = {
            type: responseTypes.TIMEDOUT,
        }

        for (let i = 0; i < choicesArr.length; i++) {
            const { is_answer, users } = choicesArr[i]
            if (users.includes(localUserInfo.full_name)) {
                tempHeader.type = is_answer
                    ? responseTypes.CORRECT
                    : responseTypes.INCORRECT
                break
            }
        }

        setHeader(tempHeader)
    }, [isTeacher, choices, localUserInfo])

    const headerProps = {
        isTeacher,
        ...header,
    }

    return header.type === responseTypes.CORRECT ? (
        <Correct {...headerProps} />
    ) : header.type === responseTypes.INCORRECT ? (
        <Incorrect {...headerProps} />
    ) : (
        <Timedout {...headerProps} />
    )
}

export default Header
